// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import React from "react";

import { useTheme } from "@3778.care/goban";

import { Covid } from "../Covid";
import { DefaultIntercomIcon } from "../DefaultIntercomIcon";
import { Inss } from "../Inss";
import { LcAgendamento } from "../LcAgendamento";
import { LcAutoavaliacao } from "../LcAutoavaliacao";
import { MapaDaVida } from "../MapaDaVida";
import { Ocupacionais } from "../Ocupacionais";
import { PbhAtestados } from "../PbhAtestados";
import { PbhDocumentais } from "../PbhDocumentais";
import { PrimaryCare } from "../PrimaryCare";

export const useIcons = (label) => {
  const theme = useTheme();

  switch (label) {
    case "aps":
      return <PrimaryCare fill={theme.palette.primary.main} />;
    case "covid":
      return <Covid />;
    case "ga":
      return <Inss fill={theme.palette.primary.main} />;
    case "lc-agendamento":
      return <LcAgendamento fill={theme.palette.primary.main} />;
    case "lc-autoavaliacao":
      return <LcAutoavaliacao fill={theme.palette.primary.main} />;
    case "mv":
      return <MapaDaVida fill={theme.palette.primary.main} />;
    case "ocp":
      return <Ocupacionais fill={theme.palette.primary.main} />;
    case "pbh-documentais":
      return <PbhDocumentais fill={theme.palette.primary.main} />;
    case "pericia-atestado":
      return <PbhAtestados fill={theme.palette.primary.main} />;
    default:
      return <DefaultIntercomIcon fill={theme.palette.primary.main} />;
  }
};
